<template>
  <div class="code">
    <div class="code__desc">
      <p>Aby przejść do dalszego etapu rejestracji, musisz podać kod z ulotki</p>
    </div>
    <form class="code__form" @submit="handleSubmit">
      <div class="code__section">
        <div class="form__row code__row">
          <img src="@/assets/svg/lock.svg" alt />
          <input type="text" class="code__input" @blur="checkCode" v-model="code" placeholder="Wpisz KOD rejestracyjny z ulotki" />
          <div v-if="error" class="form__row-error form__row-error--icon">{{error}}</div>
        </div>
        <div class="form__row code__row">
          <a @click="handleSubmit" :class="submitBtnClass">Przejdź do rejestracji</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Code",
  data() {
    return {
      submitBtnClass: 'btn',
      error: null,
      code: null
    };
  },
  methods: {
    checkCode() {
      this.error = "";
      !this.code
        ? (this.error = "Kod rejestracyjny jest wymagany")
        : null;
    },
    handleSubmit(e) {
      e.preventDefault();

      this.checkCode();

      if (this.code && !this.error) {
        this.submitBtnClass = "btn spinner spinner--running";
        axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URL}/register/check-code`,
          headers: {
            "Content-type": "application/json"
          },
          data: {
            doctorId: this.$store.state.registerData && this.$store.state.registerData.doctorId  ? this.$store.state.registerData.doctorId : '',
            code: this.code
          }
        })
          .then(() => {
            this.submitBtnClass = "btn spinner spinner--complete";
            this.$store.commit('saveRegisterData', {'code': this.code})
            setTimeout(() => this.$emit("complete", "CouponCode"), 500);
          })
          .catch(error => {
            this.submitBtnClass = "btn";
            this.error = `Wystąpił błąd: ${error.response.data.message}`;
          });
      }
    }
  }
};
</script>

<style lang="scss" >

</style>
